module.exports = __webpack_public_path__ + "static/media/img2-1.3c56cc2d.png";